import BaseAuthProvider from './BaseAuthProvider'
import {AuthProviders} from '@/domain/login/constant/authProviders'

/**
 * Password-based authentication provider
 * Uses username/email + password for authentication
 */
export default class PasswordAuthProvider extends BaseAuthProvider {
    /**
     * Authenticate with email and password
     * @param {Object} credentials - {email, password, allowRegister?, remember?}
     * @returns {Promise<Object>} {token, type: 'Token', jwt}
     */
    async authenticate(credentials) {
        const {email, password, allowRegister = false} = credentials

        const result = await this.service.getAuthToken(email, password, allowRegister)

        return {
            token: result.token,
            type: 'Token',
            jwt: result.jwt
        }
    }

    async logout(tokenData) {
        // Password auth doesn't need server-side logout
        // Token is just invalidated locally
    }

    supportsRefresh() {
        return false
    }

    getMethod() {
        return AuthProviders.PASSWORD
    }

    /**
     * Password alternatives: ldap (if enabled) OR email_token (if enabled)
     * Priority: ldap > email_token
     */
    getAlternatives(isEnabled) {
        const alternatives = []
        if (isEnabled(AuthProviders.LDAP)) {
            alternatives.push(AuthProviders.LDAP)
        }
        if (isEnabled(AuthProviders.EMAIL_TOKEN)) {
            alternatives.push(AuthProviders.EMAIL_TOKEN)
        }
        return alternatives
    }
}
